/** Library titles default to the upload's filename, e.g. "Huia-Road-4.jpg". */
const FILENAME = /\.(jpe?g|png|webp|gif|avif|svg|tiff?|bmp|heic)$/i;

/**
 * The best description available for an image, or `''` when there is none.
 *
 * Library image titles fall back to the uploaded filename when an editor never
 * renamed the asset, and reading "SolutioAir-Image-03-v3.jpg" aloud describes
 * nothing — it is worse for a screen reader than saying nothing at all, and
 * search engines discount it too. Those are dropped so the image is treated as
 * decorative instead.
 */
export const describeImage = (...candidates: (string | undefined | null)[]) =>
    candidates.find(
        (candidate) => candidate?.trim() && !FILENAME.test(candidate.trim()),
    ) ?? '';
